import { SensitiveSkin } from "./v1";

export type SensitiveSkinV1Type = keyof typeof SensitiveSkin;
export type SensitiveSkinType = SensitiveSkinV1Type;
